import React from 'react';
import { Row, Col } from 'antd';
import CancellationFeesGrid from 'app/pages/Products/components/CancellationFeesGrid';

const Page: React.FC = () => {
  return (
    <div>
      <Row>
        <Col span={24}>
          <h1 id="cancellations-header">Cancellations</h1>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <CancellationFeesGrid />
        </Col>
      </Row>
    </div>
  );
};

export default Page;